import { render, staticRenderFns } from "./PurchasesInvoiceViewDetailsPurchasesInvoiceItemForm.vue?vue&type=template&id=0fb93fa4"
import script from "./PurchasesInvoiceViewDetailsPurchasesInvoiceItemForm.vue?vue&type=script&lang=js"
export * from "./PurchasesInvoiceViewDetailsPurchasesInvoiceItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports